import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=bb783306&scoped=true"
import script from "./lists.vue?vue&type=script&lang=js"
export * from "./lists.vue?vue&type=script&lang=js"
import style0 from "./lists.vue?vue&type=style&index=0&id=bb783306&prod&scoped=true&lang=css"
import style1 from "./lists.vue?vue&type=style&index=1&id=bb783306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb783306",
  null
  
)

export default component.exports